<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-12">
        <h2>{{ $t('dynamic_dashboards') }}</h2>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'dashboard-dinamico-index' }">
              {{ $t('dynamic_dashboards') }}
            </router-link>
          </li>
          <li class="active">
            <strong>
              {{ currentItem && currentItem.Nome }}
            </strong>
          </li>
        </ol>
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInDown">
      <div class="row">
        <div class="col-md-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>{{ $t('dashboard_visualization') }}</h5>
              <a
                v-if="!isPowerBIDashboard"
                style="float: right; color: #546E7A"
                @click="handleFullscreen"
              >
                <i class="fa fa-arrows-alt" aria-hidden="true"></i>
              </a>
            </div>
            <div v-if="isPowerBIDashboard" class="wordaround" />
            <iframe
              v-if="currentItem"
              id="iframe"
              frameborder="0"
              :src="currentItem.Url"
              allow="fullscreen"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import $ from 'jquery'
import { getUserData } from '../../lib/token'
import axios from 'axios'
import hideLoading from '../../lib/hideLoading'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DashboardDinamicoShow',
  beforeRouterEnter() {
    const userData = getUserData()
    if (userData) {
      const { access_token } = userData
      axios.defaults.headers.common['Authorization'] = `bearer ${access_token}`
    }
  },
  methods: {
    handleFullscreen() {
      document.getElementById('iframe').requestFullscreen()
    },
    ...mapActions('dashboardDinamico', ['loadSingle'])
  },
  computed: {
    isPowerBIDashboard() {
      if (!this.currentItem) return false
      return this.currentItem.Url.includes('powerbi')
    },
    ...mapState('dashboardDinamico', ['currentItem'])
  },
  mounted() {
    document.title = `IMEA - ${this.$t('dynamic_dashboards')}`
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')
    hideLoading()
    this.loadSingle(this.$route.params.id)
  }
}
</script>
<style lang="css" scoped>
#iframe {
  width: 100%;
  height: 48.6vw;
  min-height: 664px;
}
.wordaround {
  position: absolute;
  background-color: #eaeaea;
  width: 260px;
  height: 30px;
  bottom: 30px;
  right: 55px;
}
</style>
